import Box from '@components/Box';
import { Button, ButtonSize, ButtonType } from '@components/Button';
import { IWrapperDetailsProps } from '../types';
import { Text, TextColor, TextSize, TextWeight } from '@components/Text';
import FormErrorMessage from '@components/FormErrorMessage';
import { Row } from '@components/Grid';

const WrapperDetails: React.FC<IWrapperDetailsProps> = (props: IWrapperDetailsProps): React.ReactElement => {
  const {
    btnAction,
    btnDisabled,
    btnPending,
    btnText,
    children,
    error,
    errorPrefix,
    isActionVisible,
    isError,
    title
  } = props;

  return (
      <div>
        <Box pb={5}>
          <Text
              color={TextColor.PRIMARY}
              size={TextSize.L}
              weight={TextWeight.BOLD}
          >
            {title}
          </Text>
        </Box>
        <Box pb={7}>
          {children}
        </Box>
        <Row
            align="center"
            gap={5}
            noWrap
        >
          {isActionVisible && (
              <Button
                  disabled={btnDisabled}
                  onClick={btnAction}
                  pending={btnPending}
                  size={ButtonSize.S}
                  title={btnText}
                  type={ButtonType.PRIMARY}
              />
          )}
          {isError && (
              <FormErrorMessage
                  error={error}
                  errorPrefix={errorPrefix ?? ''}
                  noPt
              />
          )}
        </Row>
      </div>
  );
};

export default WrapperDetails;